/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1PecegepayCreditcardPayOrderOrderid200,
  PatchApiV1PecegepayCreditcardPayOrderOrderid401,
  PatchApiV1PecegepayCreditcardPayOrderOrderid500,
  PatchApiV1PecegepayCreditcardPayOrderOrderidMutationResponse,
  PatchApiV1PecegepayCreditcardPayOrderOrderidPathParams,
} from "../../types/pecegePayCreditCardController/PatchApiV1PecegepayCreditcardPayOrderOrderid.ts";

export const patchApiV1PecegepayCreditcardPayOrderOrderidPathParamsSchema =
  z.object({
    orderId: z.string(),
  }) as unknown as ToZod<PatchApiV1PecegepayCreditcardPayOrderOrderidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const patchApiV1PecegepayCreditcardPayOrderOrderid200Schema =
  z.boolean() as unknown as ToZod<PatchApiV1PecegepayCreditcardPayOrderOrderid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1PecegepayCreditcardPayOrderOrderid401Schema =
  z.any() as unknown as ToZod<PatchApiV1PecegepayCreditcardPayOrderOrderid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1PecegepayCreditcardPayOrderOrderid500Schema =
  z.any() as unknown as ToZod<PatchApiV1PecegepayCreditcardPayOrderOrderid500>;

export const patchApiV1PecegepayCreditcardPayOrderOrderidMutationResponseSchema =
  z.lazy(
    () => patchApiV1PecegepayCreditcardPayOrderOrderid200Schema,
  ) as unknown as ToZod<PatchApiV1PecegepayCreditcardPayOrderOrderidMutationResponse>;
